import Decimal from 'decimal.js'
import { isValidEmptyValue } from '../../index'

export const getNumberSchema = (inputString: any, schema: any) => {

    inputString = inputString.test('Is valid decimal format', (val: any) => {
        if (!schema.is_required && isValidEmptyValue(val)) return true

        const normalized = normalizeDecimal(val)
        try {
            new Decimal(normalized)
            return true
        } catch {
            return false
        }
    })
    
    inputString = inputString.test('Total digits <= 29', (val: any) => {
        if (!schema.is_required && isValidEmptyValue(val)) return true

        const dec = new Decimal(normalizeDecimal(val))
        const [intPart, fracPart = ''] = dec.abs().toFixed().split('.')
        const totalDigits = intPart.replace(/^0+/, '').length + fracPart.length
        return totalDigits <= 29
    })

    inputString = inputString.test('Fraction digits <= 28', (val: any) => {
        if (!schema.is_required && isValidEmptyValue(val)) return true

        const dec = new Decimal(normalizeDecimal(val))
        const [, fracPart = ''] = dec.toFixed().split('.')
        return fracPart.length <= 28
    })

    if (typeof schema.greater_or_equal !== 'undefined') {
        inputString = inputString.test('Is greater or equal', (val: any) => {
            if (!schema.is_required && isValidEmptyValue(val)) return true
            return new Decimal(normalizeDecimal(val)).gte(new Decimal(schema.greater_or_equal))
        })
    }

    if (typeof schema.greater_than !== 'undefined') {
        inputString = inputString.test('Is greater than', (val: any) => {
            if (!schema.is_required && isValidEmptyValue(val)) return true
            return new Decimal(normalizeDecimal(val)).gt(new Decimal(schema.greater_than))
        })
    }

    if (typeof schema.less_or_equal !== 'undefined') {
        inputString = inputString.test('Is less or equal', (val: any) => {
            if (!schema.is_required && isValidEmptyValue(val)) return true
            return new Decimal(normalizeDecimal(val)).lte(new Decimal(schema.less_or_equal))
        })
    }

    if (typeof schema.less_than !== 'undefined') {
        inputString = inputString.test('Is less than', (val: any) => {
            if (!schema.is_required && isValidEmptyValue(val)) return true
            return new Decimal(normalizeDecimal(val)).lt(new Decimal(schema.less_than))
        })
    }

  if (schema.is_required) {
    inputString = inputString.required()
  }
  if (!schema.is_required) {
    inputString = inputString
      .notRequired()
      .nullable()
      .transform((_: any, val: any) => isValidEmptyValue(val) ? null : String(val))
  }
  return inputString
}

export function normalizeDecimal(val: string | number): string {
    return String(val).replace(',', '.').trim()
}